import { connect } from "react-redux";
import { commonStyle } from "../../../../assets/css/css";
import { useState } from "react";
import '../styles/CallMetricTracker.css';
import { HiRefresh } from "react-icons/hi";
import { toast } from "react-toastify";
import Topbar from "../../../../common/component/topbar/Topbar";
import Sidebar from "../../../../common/componentV2/sidebar/Sidebar";
import { GET } from "../../../../services/HttpRequests";

import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core';

const moment = require('moment-timezone');
const todayDate = moment().tz('Asia/Kolkata').format('YYYY-MM-DD');

const organisationId = localStorage.getItem('doosra-biz-organisation-id');
const SEARCH_BY_FILTERS = {
  REFERENCE_ID: "REFERENCE_ID",
  AGENT_NUMBER: "AGENT_NUMBER",
  CUSTOMER_NUMBER: "CUSTOMER_NUMBER"
}

const analyticsUrl = process.env.REACT_APP_ANALYTICS_API;

function calculateDuration(start, end) {
  if (!start || !end) {
    return "-";
  }
  return Math.abs(new Date(end).getTime() - new Date(start).getTime());
}

function convertToIST(date) {
  if (!date) return "-";
  return moment(date).tz('Asia/Kolkata').format("YYYY-MM-DD hh:mm:ss a");
}

function callStatusFormat(status) {
  if (status) {
    if (status === "not_answered") return "Not Answered";
    if (status === "answered") return "Answered";
  }
  return "-";
}

const AbstractTableRow = ({ name, value, time }) => {
  if (!value) return null;

  return (
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell>{value}&nbsp;{time || ""}</TableCell>
    </TableRow>
  );
};

const AbstractTable = ({ callData }) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="abstract table">
        <TableHead style={{ backgroundColor: "lightgrey" }}>
          <TableRow>
            <TableCell key={"key"}><strong>Key</strong></TableCell>
            <TableCell key={"value"}><strong>Value</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <AbstractTableRow name={"callId"} value={callData?.newOutgoingCallDoc?._id?.toString()} />
          <AbstractTableRow name={"Initiator Number"} value={callData?.newOutgoingCallDoc?.initiatorNumber} />
          <AbstractTableRow name={"Receiver Number"} value={callData?.newOutgoingCallDoc?.destinationNumber} />
          <AbstractTableRow name={"DID Number"} value={callData?.newOutgoingCallDoc?.didNumber} />
          <AbstractTableRow name={"Call Start Time"} value={convertToIST(callData?.outgoingCallDoc?.createdAt)} />
          <AbstractTableRow name={"Call End Time"} value={convertToIST(callData?.outgoingCallDoc?.callEndedAt)} />
          <AbstractTableRow name={"Call Status"} value={callStatusFormat(callData?.newOutgoingCallDoc?.status)} />
          <AbstractTableRow name={"Hangup Reason"} value={callData?.newOutgoingCallDoc?.inHouseSupplementalData?.hangup_cause} />
          <AbstractTableRow name={"Api Response Time"} value={callData?.auditLogDoc?.responseTime || "-"} time="ms" />
          <AbstractTableRow name={"Initiator Ring Delay"} value=
            {
              (callData?.outgoingCallDoc?.bridgeCreationDuration || 0) +
              (callData?.outgoingCallDoc?.initiatorChannelCreationDuration || 0) +
              (callData?.outgoingCallDoc?.initiatorCreationToRingDelay || 0)
            }
            time="ms"
          />
          <AbstractTableRow name={"Webhook Delay"} value=
            {
              calculateDuration(callData?.outgoingCallDoc?.webhookQueuedAt, callData?.outgoingCallDoc?.webhookConsumedAt)
            }
            time="ms"
          />
          <AbstractTableRow name={"Webhook Response Duration"} value=
            {
              calculateDuration(callData?.outgoingCallDoc?.webhookConsumedAt, callData?.outgoingCallDoc?.webhookResponseReceivedAt)
            }
            time="ms"
          />
          <AbstractTableRow name={"Webhook Status Code"} value=
            {
              callData?.webhookLogDoc?.statusCode
            }
          />
          <AbstractTableRow name={"Webhook Response"} value=
            {
              callData?.webhookLogDoc?.response?.message || callData?.webhookLogDoc?.response || "-"
            }
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const SuggestedCallsContainer = ({ suggestedCalls, fetchData }) => {
  return <Accordion defaultExpanded>
    <AccordionSummary
      expandIcon={<b>{'>'}</b>}
      aria-controls="panel1-content"
      id="panel1-header"
    >
      <span className="SuggestedCallsContainerHeader">Suggested Calls ({suggestedCalls?.length || 0})</span>
    </AccordionSummary>
    <AccordionDetails>
      {suggestedCalls?.length > 0 ?
        <TableContainer component={Paper}>
          <Table aria-label="abstract table">
            <TableHead style={{ backgroundColor: "lightgrey" }}>
              <TableRow style={{
                display: "table",
                tableLayout: "fixed",
                width: "100%"
              }}>
                <TableCell key={"agentNumber"}><strong>Agent Number</strong></TableCell>
                <TableCell key={"destinationNumber"}><strong>Customer Number</strong></TableCell>
                <TableCell key={"createdAt"}><strong>Call Start At</strong></TableCell>
                <TableCell key={"action"}><strong></strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody
              style={{
                display: "block",
                maxHeight: 300,
                overflowY: "auto"
              }}
            >
              {suggestedCalls?.map(doc => <TableRow
                style={{
                  display: "table",
                  tableLayout: "fixed",
                  width: "100%"
                }}
              >
                <TableCell>{doc?.initiatorNumber}</TableCell>
                <TableCell>{doc?.destinationNumber}</TableCell>
                <TableCell>{convertToIST(doc?.createdAt)}</TableCell>
                <TableCell>
                  <button className="CallMetricTrackerFilterSearchButton"
                    onClick={() => fetchData(doc?._id?.toString())}
                  >GET DATA</button>
                </TableCell>
              </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer> : <NoCallsComponent />}
    </AccordionDetails>
  </Accordion>
}


const LoaderComponent = () => {
  return <div style={{ color: '#196cca', fontSize: "16px", fontWeight: "bold" }} >
    <HiRefresh />&nbsp;Loading...
  </div>;
}

const NoDataFoundComponent = () => {
  return <div style={{ color: '#196cca', fontSize: "16px", fontWeight: "bold" }} >
    No data found
  </div>;
}

const NoCallsComponent = () => {
  return <div style={{ color: '#196cca', fontSize: "16px", fontWeight: "bold" }} >
    No calls
  </div>;
}


function CallMetricTracker(props) {


  const [isLoading, setIsLoading] = useState(false);
  const [callData, setCallData] = useState(null);
  const [searchBy, setSearchBy] = useState(SEARCH_BY_FILTERS.REFERENCE_ID);
  const [searchValue, setSearchValue] = useState("");
  const [searchDate, setSearchDate] = useState(todayDate);
  const [suggestedCalls, setSuggestedCalls] = useState([]);
  const [showCallSuggestions, setShowCallSuggestions] = useState(false);

  const fetchData = async (passedCallId) => {
    try {
      if (searchBy === SEARCH_BY_FILTERS.REFERENCE_ID) {
        setShowCallSuggestions(false);
        setSuggestedCalls([]);
      }
      setIsLoading(true);
      const response = await GET(analyticsUrl + `metrics/get-call-tracking-documents?referenceId=${passedCallId}`);
      setCallData(response?.data?.response || null);
      setIsLoading(false);
    } catch (error) {
      toast.error("Error fetching call data");
      setIsLoading(false);
      setCallData(null);
      console.log(error);
    }
  }

  const fetchCalls = async () => {
    try {
      setIsLoading(true);

      let searchCondition = "";
      if (searchBy === SEARCH_BY_FILTERS.AGENT_NUMBER) {
        searchCondition = `agentNumber=${searchValue}`;
      } else if (searchBy === SEARCH_BY_FILTERS.CUSTOMER_NUMBER) {
        searchCondition = `customerNumber=${searchValue}`;
      }

      const response = await GET(analyticsUrl + `metrics/call-doc-by-number?organisationId=${organisationId}&date=${searchDate}&` + searchCondition);
      setSuggestedCalls(response?.data?.response || []);
      setShowCallSuggestions(true);
      setCallData(null);
      setIsLoading(false);
    } catch (error) {
      toast.error("Error searching calls");
      setIsLoading(false);
      setSuggestedCalls([]);
      console.log(error);
    }
  }

  const handleSearchBy = (e) => {
    setSearchBy(e.target.value);
    setSearchValue("");
  }

  const handleSearchValue = (e) => {
    setSearchValue(e.target.value)
  }

  return (<div className={`${props.className}`}>
    <Topbar />
    <div style={{ display: 'flex', height: 'calc(100vh - 72px)' }}>
      <Sidebar />
      <div className="CallMetricTrackerPageContainer">
        <div className='CallMetricTracker'>
          <div className='CallMetricTrackerHeader'>
            <div className='CallMetricTrackerRefreshComponent'>
              <div className='CallMetricTrackerName'>Track Your Call</div>
            </div>
            <div className='CallMetricTrackerRefreshComponent'>
              <div className='CallMetricTrackerFilter'>
                <div className='CallMetricTrackerFilterHeader'>SEARCH BY &nbsp;</div>
                <div>
                  <select
                    className='CallMetricTrackerSearchDropDown'
                    onChange={handleSearchBy}
                  >
                    <option value={SEARCH_BY_FILTERS.REFERENCE_ID}>REFERENCE ID</option>
                    <option value={SEARCH_BY_FILTERS.AGENT_NUMBER}>AGENT NUMBER</option>
                    <option value={SEARCH_BY_FILTERS.CUSTOMER_NUMBER}>CUSTOMER NUMBER</option>
                  </select>
                  &nbsp;
                </div>
                <div>
                  <input
                    type="text"
                    className='CallMetricTrackerSearchValue'
                    placeholder="Enter value ..."
                    value={searchValue}
                    onChange={handleSearchValue}
                  />
                  &nbsp;
                </div>
                {[SEARCH_BY_FILTERS.AGENT_NUMBER, SEARCH_BY_FILTERS.CUSTOMER_NUMBER].includes(searchBy) && < div >
                  <input
                    type="date"
                    className='CallMetricTrackerDateFilter'
                    value={searchDate}
                    onChange={(e) => setSearchDate(e.target.value)}
                  />
                </div>
                }
                <div>
                  <button
                    className="CallMetricTrackerFilterSearchButton"
                    onClick={() => {
                      if (searchBy === SEARCH_BY_FILTERS.REFERENCE_ID) {
                        fetchData(searchValue);
                      } else {
                        fetchCalls();
                      }
                    }}
                  >
                    {searchBy === SEARCH_BY_FILTERS.REFERENCE_ID ? "GET DATA" : "SEARCH CALLS"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showCallSuggestions && <SuggestedCallsContainer
            suggestedCalls={suggestedCalls}
            fetchData={(callId) => {
              fetchData(callId);
            }}
          />}

          {/* Inner Tab Area - Start */}

          <div className='CallMetricTrackerContainer'>
            {isLoading ?
              <LoaderComponent /> :
              (callData?.newOutgoingCallDoc) ?
                <AbstractTable
                  callData={callData}
                /> :
                <NoDataFoundComponent />
            }
          </div>

          {/* Inner Tab Area - End  */}
        </div>
      </div>
    </div>
  </div >);
}

const mapStateToProps = (state) => ({
  sidebarClosed: state.sidebar.sidebarClosed,
  userDetails: state.recovery.userDetails,
});

export default commonStyle(connect(mapStateToProps, {})(CallMetricTracker));